import { useEffect, useState } from 'react';
import styles from './SearchComponent2.module.css';
import { SelectPicker, InputPicker } from 'rsuite';
import api from '../../api';
import { frontDB } from '../../frontDB';

function SearchComponent2({ readonly, onComponentChange, defaultComponentId, defaultComponentName, locationId }) {
	let { location } = frontDB();

	let [componentsOptions, setComponentsOptions] = useState([]);
	let [componentId, setComponentId] = useState(undefined);
	let [componentName, setComponentName] = useState('');
	let [latestSearchRequest, setLatestSearchRequest] = useState(null);

	let searchInputHandler = (searchValue) => {
		if (latestSearchRequest) {
			clearTimeout(latestSearchRequest);
		}

		latestSearchRequest = setTimeout(() => {
			getComponents(searchValue);
		}, 500);

		setLatestSearchRequest(latestSearchRequest);
	};

	let getComponents = async (searchValue) => {
		let params = {
			locationId: locationId,
			searchValue: searchValue,
			activePage: 1,
			itemsPerPage: 10,
		};

		let components = await api.component.searchComponent(params);
		let componentsOptions = components.map((item) => ({ label: `${item.name} | ${item.number}`, value: item.name }));

		setComponentsOptions(componentsOptions);
	};

	let componentHandler = (v) => {
		//setComponentId(v)
		setComponentName(v);
		onComponentChange(v);
	};

	const downloadComponent = async () => {
		const { component } = await api.component.getById(defaultComponentId);

		if (!component) return;

		let componentsOptions = [component].map((item) => ({ label: `${item.name} `, value: item.name }));

		setComponentsOptions(componentsOptions);
		setComponentName(component.name);
		//setComponentId(component._id)
	};

	// useEffect(() => {
	// 	if (defaultComponentId) {
	// 		downloadComponent();
	// 	} else {
	// 		//getComponents(defaultComponentName);
	// 		if (defaultComponentName == undefined) {
	// 			setComponentsOptions({});
	// 		} else {
	// 			setComponentsOptions({
	// 				label: `${defaultComponentName} `,
	// 				value: `${defaultComponentName}`,
	// 			});
	// 		}
	// 		setComponentName(defaultComponentName);
	// 	}
	// }, []);

	useEffect(() => {
		if (defaultComponentId) {
			downloadComponent();
		} else {
			getComponents(defaultComponentName);
			setComponentsOptions({ label: `${defaultComponentName} `, value: defaultComponentName });
			setComponentName(defaultComponentName);
		}
	}, []);

	return (
		<>
			<InputPicker
				readOnly={readonly}
				cleanable={false}
				value={componentName}
				onChange={componentHandler}
				onSearch={searchInputHandler}
				data={componentsOptions}
				style={{ width: 250 }}
				placeholder={'Select component'}
			/>
		</>
	);
}

export default SearchComponent2;
